import React, { useState } from "react";
import { Box, Button, CircularProgress, Typography, IconButton } from "@material-ui/core";
import { CloudUpload, Delete } from "@material-ui/icons";
import { toast } from "react-toastify";
import api from "../../services/api";
import { getBackendUrl } from "../../config";

const ImageUpload = ({ value, onChange, label, recommendedSize, helperText }) => {
    const [uploading, setUploading] = useState(false);

    const getImageUrl = (url) => {
        if (!url) return null;
        let cleanUrl = url;
        if (cleanUrl.includes(",")) {
            cleanUrl = cleanUrl.split(",")[0].trim();
        }
        if (cleanUrl.startsWith("http") || cleanUrl.startsWith("//")) return cleanUrl;
        const backendUrl = getBackendUrl();
        return `${backendUrl}/public/${cleanUrl}`;
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Validate file type
        if (!file.type.startsWith("image/")) {
            toast.error("Por favor, selecione uma imagem válida");
            return;
        }

        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            toast.error("Imagem muito grande. Máximo 5MB");
            return;
        }

        setUploading(true);
        try {
            const formData = new FormData();
            formData.append("file", file);

            const { data } = await api.post("/chatbots/upload-media", formData, {
                headers: { "Content-Type": "multipart/form-data" }
            });

            // The response should contain the URL
            const imageUrl = data.url || data.mediaUrl || data;
            onChange(imageUrl);
            toast.success("Imagem enviada com sucesso!");
        } catch (error) {
            console.error("Upload error:", error);
            toast.error("Erro ao enviar imagem");
        } finally {
            setUploading(false);
        }
    };

    const handleRemove = () => {
        onChange("");
    };

    return (
        <Box>
            <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
                {label}
                {recommendedSize && ` (Recomendado: ${recommendedSize})`}
            </Typography>

            {value ? (
                <Box display="flex" alignItems="center" gap={2}>
                    <img
                        src={getImageUrl(value)}
                        alt="Preview"
                        style={{
                            maxWidth: 200,
                            maxHeight: 100,
                            borderRadius: 8,
                            border: "1px solid #ddd",
                            objectFit: "contain"
                        }}
                    />
                    <IconButton size="small" onClick={handleRemove} color="secondary">
                        <Delete />
                    </IconButton>
                </Box>
            ) : (
                <Box>
                    <input
                        accept="image/*"
                        style={{ display: "none" }}
                        id={`image-upload-${label}`}
                        type="file"
                        onChange={handleFileChange}
                        disabled={uploading}
                    />
                    <label htmlFor={`image-upload-${label}`}>
                        <Button
                            variant="outlined"
                            component="span"
                            startIcon={uploading ? <CircularProgress size={20} /> : <CloudUpload />}
                            disabled={uploading}
                        >
                            {uploading ? "Enviando..." : "Escolher Imagem"}
                        </Button>
                    </label>
                </Box>
            )}

            {helperText && (
                <Typography variant="caption" color="textSecondary" display="block" style={{ marginTop: 4 }}>
                    {helperText}
                </Typography>
            )}
        </Box>
    );
};

export default ImageUpload;
